module.exports = __webpack_public_path__ + "assets/img/marriage-verify-bg.c1c22219.png";